<style lang="scss">
  @import "~@/assets/css/var";

  .ls-popup {
    position: relative;
    z-index: 1000;

    > section {
      position: relative;
    }

    .article__block {
      border: 0;
      padding: 0 10px 10px 10px;
    }

    &__back {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, .3);
    }

    &__panel {
      position: fixed;
      padding: 15px;
      top: 0;
      right: -100%;
      bottom: 0;
      background: #fff;
      transition: right .3s;
      box-shadow: -3px 0 10px hsla(0, 0%, 53.3%, .7);

      &.show {
        right: 0;
      }
    }

    &__close {
      position: absolute;
      left: -41px;
      background: #fff;
      width: 40px;
      height: 40px;
      top: 0;
      border-right: 1px solid $greyBorder;
      line-height: 40px;
      text-align: center;
      font-size: 20px;
      cursor: pointer;
      color: #ff6b6b;

      &:hover {
        background: #ff6b6b;
        color: #fff
      }
    }

    &__content {
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none
      }
    }

    &__footer {
      margin-top: 15px;
      text-align: center;
    }
  }
</style>
<template>
  <div class="ls-popup">
    <div class="ls-popup__back" v-show="show"></div>
    <div style="position:relative">
      <div class="ls-popup__panel flex flex-column" :class="{show: show}" :style="{width: width}">
        <div class="ls-popup__close" @click="cancel"><i class="el-icon-close"></i></div>
        <div class="container__title container__title-line" v-show="!!title">
          <span>{{title}}</span>
          <slot name="header"></slot>
        </div>
        <div class="ls-popup__content flex-item" :class="contentClass">
          <slot></slot>
        </div>
        <div class="ls-popup__footer" v-if="showOperation">
          <slot name="footer"></slot>
          <el-button size="mini" v-show="!!sureTxt" class="btn-solid-green" @click="submit"
                     icon="el-icon-check" :loading="loading" :disabled="auth | auth">{{sureTxt}}
          </el-button>
          <el-button size="mini" v-show="!!cancelTxt" class="btn-red" @click="cancel"
                     style="margin-left: 25px;" icon="el-icon-close">{{cancelTxt}}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LsPopup',
    props: {
      auth: {},
      contentClass: {},
      show: {
        type: Boolean,
        default: false,
      },
      showOperation: {
        type: Boolean,
        default: true,
      },
      sureTxt: {
        default: '确定'
      },
      cancelTxt: {
        default: '取消'
      },
      loading: {
        type: Boolean,
        default: false,
      },
      width: {
        default: '65%'
      },
      title: {},
    },
    methods: {
      submit() {
        this.$emit('save')
      },
      cancel() {
        this.$emit('close')
        this.$emit('update:show', false)
      },
    },
  }
</script>